import { MODEL_SOURCES } from 'Pods/ThreeDStudio/Services/Constants/modelSources'

/**
 * Reports whether the schema a provider uses for an action declares a given
 * input parameter. Schemas that only pin the parameter through `active_if`
 * (e.g. `ultra_mode: { const: false }`) do not count as supporting it.
 *
 * @param {string} action - Generation action, e.g. ACTION.IMAGE_TO_3D.
 * @param {string} provider - Provider id, e.g. PROVIDER.MESHY.
 * @param {string} param - Schema parameter name, e.g. "smart_low_poly".
 * @returns {boolean}
 */
export const providerSupportsParam = (action, provider, param) => MODEL_SOURCES.some((schema) => (
  schema.action === action
    && schema.provider === provider
    && schema.input_schema?.properties?.[param] !== undefined
))
